export default function ColorPicker({ value, setValue, label }) {
  return (
    <div className="w-full flex items-center justify-between py-2">
      <label
        htmlFor="hs-color-input"
        className="text-sm font-medium text-gray-700"
      >
        {label}
      </label>
      <div className="relative">
        <input
          type="color"
          id="hs-color-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="h-9 w-9 border border-gray-300 rounded-md shadow-sm cursor-pointer transition duration-150 hover:ring-2 hover:ring-blue-400"
          title="Choose your color"
        />
      </div>
    </div>
  );
}
